/*
  The Phase 3 design system's settings, fixed at the owner's choices.

  Job 29. Built as a switches panel on the `phase-3-preview` branch so the owner
  could answer the open questions on real screens; **went live on his word on 13
  September 2026, "phone looked good, go live"**, with the panel removed and
  every value below fixed. The record of each choice is
  `docs/design/phase-3/DECISIONS.md`.

  Nothing is read from or written to the browser's storage any more: a value a
  person tried in the preview must never change what the live app does.

  Each value is written onto <html> as a data attribute or a CSS variable, and
  `phase3.css` does the rest. Nothing here touches data, sign-in or permissions.
*/
import { useSyncExternalStore } from 'react';

export const DEFAULTS = {
  dialogGlass: true,    // dialogs are glass
  dialogFill: 50,       // a question dialog; a form or a list is 60, in roles.css
};

/* The moving background's settings (theme, motion, strength, speed, push,
   veil, adaptive chrome fill) went with it on 14 September 2026, theme system
   phase 3. The top bar is glass at 15% in every theme, in roles.css. */

let state = { ...DEFAULTS };
const listeners = new Set();

export function apply(s = state) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const d = root.dataset;
  d.p3 = 'on';
  d.p3Dialog = s.dialogGlass ? 'glass' : 'solid';
  root.style.setProperty('--p3-dialog-fill', String(s.dialogFill / 100));
}

/* Used by the photographer to hold the drift and the push still for a picture.
   It changes this page only and saves nothing. */
export function set(patch) {
  state = { ...state, ...patch };
  apply(state);
  listeners.forEach(fn => fn());
}

export function get() { return state; }

function subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); }

export function useSettings() {
  return useSyncExternalStore(subscribe, get, get);
}
